import { Box, Container, Heading, Text, VStack } from '@chakra-ui/react';

function About() {
  return (
    <Box>
      <Container maxW="800px" py={12}>
        <VStack spacing={12} align="stretch">
          <Heading as="h1" size="2xl" textAlign="center" color="teal.800">
            About Mock Me, Please!
          </Heading>

          <Box>
            <Text fontSize="lg" lineHeight="tall">
              Mock Me, Please! was founded in 2024 by a professional orchestral cellist who understands the unique challenges of the audition process. After taking over a dozen auditions themselves, they recognized the need for accessible, high-quality mock audition opportunities.
            </Text>
            <Text fontSize="lg" lineHeight="tall" mt={4}>
              Our mission is to make professional audition preparation more accessible and less intimidating. We believe that every musician deserves the opportunity to prepare thoroughly for their auditions with experienced mentors who have been there before.
            </Text>
          </Box>

          <Box textAlign="center" mt={8}>
            <Heading size="lg" color="teal.800" mb={4}>
              Join Our Community
            </Heading>
            <Text fontSize="lg">
              Whether you're preparing for an audition or looking to share your expertise, Mock Me, Please! is here to support your musical journey.
            </Text>
          </Box>
        </VStack>
      </Container>
    </Box>
  );
}

export default About; 